import dynamic from 'next/dynamic'
import { Loading } from 'common/widgets'


const Chart = dynamic(() => import('./Chart'), { loading: () => <Loading isLoading fontSize={48} /> })

export default Chart
